// extracted by mini-css-extract-plugin
module.exports = {"userWidget":"UserWidget_userWidget__gBuc6","userWidgetImg":"UserWidget_userWidgetImg__1j2fW","userWidgetName":"UserWidget_userWidgetName__3L57Q"};